import React, { useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Newspaper, PlayCircle, Network } from "lucide-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./sidebar.scss";
import { fetchNew, fetchService, fetchVideo } from "../../api/newsService";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      type="button"
      className={`${className} sidebar-arrow sidebar-arrow--next`}
      style={style}
      onClick={onClick}
      aria-label="next"
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      type="button"
      className={`${className} sidebar-arrow sidebar-arrow--prev`}
      style={style}
      onClick={onClick}
      aria-label="previous"
    />
  );
}

const Sidebar = ({ variant = "default", currentServiceId, newsPage = 1 }) => {
  const [postVideo, setPostVideo] = useState([]);
  const [postNew, setPostNew] = useState([]);
  const [postService, setPostService] = useState([]);

  const getData = async () => {
    const res = await fetchNew("", 393, newsPage, 5);
    const newsList = res?.data?.data?.lstNews || [];

    if (newsList.length > 0) {
      setPostNew(newsList);
      return;
    }

    if (newsPage !== 1) {
      const fallbackRes = await fetchNew("", 393, 1, 5);
      if (fallbackRes?.data?.data?.lstNews) {
        setPostNew(fallbackRes.data.data.lstNews);
      }
    }
  };

  const getVideo = async () => {
    try {
      const res = await fetchVideo();
      if (res?.data?.data?.lstVideo?.length > 0) {
        setPostVideo(res.data.data.lstVideo);
      } else {
        setPostVideo([]);
      }
    } catch (error) {
      setPostVideo([]);
    }
  };

  const getService = async () => {
    const res = await fetchService({ page: 1, size: 1000 });
    if (res?.data?.data?.lstNews) {
      setPostService(res.data.data.lstNews);
    }
  };

  useEffect(() => {
    if (variant === "service") {
      getService();
      return;
    }

    getData();
    getVideo();
  }, [variant, newsPage]);

  const serviceItems = useMemo(
    () => postService.filter((item) => item.id !== currentServiceId),
    [postService, currentServiceId]
  );

  if (variant === "service") {
    return (
      <div className="side_bar">
        <section className="sidebar-panel sidebar-panel--news">
          <div className="sidebar-panel__head">
            <div className="sidebar-panel__title-wrap">
              <span className="sidebar-panel__icon">
                <Network size={18} />
              </span>
              <h3>Dịch vụ khác</h3>
            </div>
          </div>

          <div className="sidebar-news-list">
            {serviceItems.map((post, index) => (
              <Link
                key={post.id || index}
                to={`/dich-vu-ha-tang/${post.id}`}
                className="sidebar-news-item"
              >
                <div className="sidebar-news-item__thumb">
                  <img src={post.image} alt={post.title} />
                </div>
                <div className="sidebar-news-item__body">
                  <h4 className="!text-base text-gray-700">{post.title}</h4>
                  <div className="sidebar-news-item__date">
                    <CalendarDays size={14} />
                    <span className="!text-gray-400 text-sm">{post.createDate}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </div>
    );
  }

  const videos = postVideo;

  const settings = {
    dots: true,
    infinite: videos.length > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: videos.length > 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <div className="side_bar">
      <section className="sidebar-panel sidebar-panel--news">
        <div className="sidebar-panel__head">
          <div className="sidebar-panel__title-wrap">
            <span className="sidebar-panel__icon">
              <Newspaper size={18} />
            </span>
            <h3>Tin nổi bật</h3>
          </div>
          <Link to="/tin-noi-bat" className="sidebar-panel__head-link">
            Xem tất cả
            <ArrowRight size={15} />
          </Link>
        </div>

        <div className="sidebar-news-list">
          {postNew?.slice(0, 5).map((post, index) => (
            <Link key={post.id || index} to={`/tin-noi-bat/${post.id}`} className="sidebar-news-item">
              <div className="sidebar-news-item__thumb">
                <img src={post.image} alt={post.title} />
              </div>
              <div className="sidebar-news-item__body">
                <h4 className="!text-base text-gray-700">{post.title}</h4>
                <div className="sidebar-news-item__date">
                  <CalendarDays size={14} />
                  <span className="!text-gray-400 text-sm">{post.createDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {videos.length > 0 ? (
        <section className="sidebar-panel sidebar-panel--video">
        <div className="sidebar-panel__head">
          <div className="sidebar-panel__title-wrap">
            <span className="sidebar-panel__icon">
              <PlayCircle size={18} />
            </span>
            <h3>Video</h3>
          </div>
          <Link to="/thu-vien-video" className="sidebar-panel__head-link">
            Thư viện
            <ArrowRight size={15} />
          </Link>
        </div>

        <div className="sidebar-video-slider">
          <Slider {...settings}>
            {videos?.slice(0, 4).map((video, index) => (
              <div key={video.id || index} className="sidebar-video-slide">
                <Link to={`/thu-vien-video/${video.id}`} className="sidebar-video-card">
                  <div className="sidebar-video-card__media">
                    <img src={video.image} alt={video.title} />
                    <span className="sidebar-video-card__play">
                      <PlayCircle size={22} />
                    </span>
                  </div>
                  <div className="sidebar-video-card__content">
                    <h4>{video.title}</h4>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
        </section>
      ) : null}
    </div>
  );
};

export default Sidebar;
